/* istanbul ignore file @preserve */ //
// DO NOT EDIT!
// This file was autogenerated by Eddie.
// Changes may cause incorrect behavior and will be lost when the file is regenerated.
//
// Run `npx eddie update workspace` to regenerate.
//
export const APP_NAME = 'editorials';
export const PACKAGE_NAME = '@ori-appshell/editorials';
export const TEAM_NAME = 'Presentation';
export const EMOTION_CACHE_KEY = "".concat(APP_NAME, "-emotion-cache-key");
